<div class="import-progress-dialog">

  <!-- Title -->
  <h5 class="text-18-500 color-8 ri-pb-2 text-center">
    {{ ss.t('dataUploadingProcess_title') }}
  </h5>

  <!-- Icon/Status Indicator -->
  <div class="status-indicator">
    <div class="icon-container">
      <app-svg [name]="statusIcon()" [color]="statusColor()" class="status-icon"></app-svg>
    </div>
    <div class="upload-animation">
      <app-svg name="mobile" [color]="ss.theme().color1" class="upload-device"></app-svg>
      <app-svg name="importDialogRightArrow" [color]="ss.theme().color7"></app-svg>
      <app-svg name="cloud" [color]="ss.theme().color1" class="upload-cloud"></app-svg>
    </div>
    
  </div>

  <!-- File Info -->
  <!-- <div class="file-info ri-pb-4">
    <p class="text-14-400 color-7 text-center">{{ fileName }}</p>
    <p class="text-12-400 color-7 text-center">{{ formatFileSize(fileSize) }}</p>
  </div> -->
  <div class="flex items-center justify-between ri-mb-2 w-full">

    <p class="text-16-600 color-35 text-center">
      {{ ss.t('dataUploadingProcess_uploadingInfo') }}
    </p>

    <p class="text-16-600 color-35 text-center">{{ progressPercentage() }}</p>
  </div>

  <!-- Progress Bar -->
  @if (showProgressBar()) {
  <div class="progress-section ri-pb-4">
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="uploadProgress()"></div>
    </div>
  </div>
  }

  <!-- Status Message - Reactive based on idle time (matches Flutter) -->
  <div class="status-message ri-pb-4">
    <p class="text-14-400 color-7 text-center">
      {{ statusMessage() }}
    </p>
  </div>


  <!-- @else if (status() === 'processing') {
    <p class="text-14-400 color-7 text-center">
      {{ ss.t('dataUploadingProcess_uploadingInfo') }}
    </p>
    } @else if (status() === 'completed') {
    <p class="text-14-400 color-12 text-center">
      {{ ss.t('dataUploadingProcess_completedInfo') }}
    </p>
    } @else if (status() === 'error') {
    <p class="text-14-400 color-11 text-center">
      {{ errorMessage() || 'An error occurred during import' }}
    </p>
    }
  </div> -->

  <!-- Action Button (only for error or completed states) -->

  <div class="flex justify-end w-full ri-mt-2">
    <button class="color-7" (click)="cancel()">
      {{ ss.t('common_buttonCancel') }}
    </button>
  </div>

</div>